var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 d-flex align-items-center"},[_c('div',{staticClass:"pin-icon"}),_c('div',[_c('span',[_vm._v(_vm._s(_vm.address.main_text)+" ")]),_c('span',[_vm._v(_vm._s(_vm.address.secondary_text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }